import React from 'react';

import { twMerge } from 'tailwind-merge';

import Typography from 'components-new/typography/typography';

interface FormCardProps {
  infoContainer: {
    title: string;
    content: string;
  };
  children: React.ReactNode;
}

const formInfoContainerClassName = twMerge(
  'p-5 md:w-1/2 lg:w-1/3',
  'bg-gray50 rounded-l-md',
  'border-r border-gray100',
);
const formContainerClassName = twMerge('p-5 h-full flex-1');

const FormCard: React.FC<FormCardProps> = ({ infoContainer, ...props }) => {
  return (
    <div className="flex flex-col md:flex-row border bg-white rounded-lg">
      <div className={formInfoContainerClassName}>
        <Typography as="h3" variant="body-large-bold" className="mb-3">
          {infoContainer.title}
        </Typography>
        <Typography
          as="p"
          variant="body-medium"
          className="leading-6 text-gray400"
        >
          {infoContainer.content}
        </Typography>
      </div>
      <div className={formContainerClassName}>{props.children}</div>
    </div>
  );
};

export default FormCard;
